import { NavLink } from 'react-router';
import styled from 'styled-components';

import { ButtonElement } from '@components/button';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 125px 0;
`;

export const Container = styled.div`
	max-width: 600px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
`;
export const Header = styled.div`
	padding: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
`;

export const Title = styled.div`
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
`;

export const Body = styled.div`
	padding: 16px;
`;

export const Text = styled.p`
	margin: 0;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const SupportButton = styled(NavLink)<{ $color?: string }>`
	${ButtonElement} {
		background-color: ${({ $color }) => $color};
	}

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const Links = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 16px;
	margin-top: 16px;
`;
